import {FormattedMessage} from "react-intl";
import StarIcon from "@/assets/icons/icon-star.svg?react";
import LiftagoLogo from "@/assets/liftago-logo.svg?react";
import {getLanguage} from "@/translations";
import styles from "./Branding.module.css";

/**
 * Branding - Brand header with logo and trust indicators
 *
 * Displays Liftago branding with:
 * - Logo
 * - Rating (4.9 stars)
 * - Review count
 * - Trust indicators
 *
 * Links to Liftago website based on current language.
 *
 * @example
 * <Branding />
 */
export function Branding() {
    const currentLanguage = getLanguage();
    const brandingUrl = currentLanguage === "cs" ? "https://liftago.cz" : "https://liftago.cz/en";

    return (
        <a
            href={brandingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.brandingLink}
        >
            <div className={styles.branding}>
                <LiftagoLogo
                    className={styles.logo}
                    height={24}
                    width={39}
                    role="img"
                    aria-label="Liftago"
                />
                <div>
                    <div className={styles.title}>
                        <FormattedMessage id="public_order_brand_title" />
                    </div>
                    <div className={styles.ratingContainer}>
                        <StarIcon height={14} width={14} role="img" aria-label="Rating star" />
                        <span className={styles.rating}>4,9</span>
                        <span className={styles.reviews}>
                            <FormattedMessage
                                id="public_order_brand_reviews"
                                values={{count: "51,6"}}
                            />
                        </span>
                        <span className={styles.trustIndicators}>
                            <FormattedMessage id="public_order_brand_trust_indicator_quality_cars" />
                        </span>
                        <span className={styles.trustIndicators}>
                            <FormattedMessage id="public_order_brand_trust_indicator_verified_drivers" />
                        </span>
                    </div>
                </div>
            </div>
        </a>
    );
}
